import { createContext } from 'lib/context';
import { MooringOfferDto, MooringReviewDto } from 'models/mooring';

interface OfferViewState {
  offer: MooringOfferDto;
  offerReview?: MooringReviewDto;
  inReview: boolean;
  isLocked: boolean;
}

// Create typed context descriptor
export const OfferViewContext = createContext<OfferViewState>(class OfferViewContext {});

export type { OfferViewState };
